import apiClient from './api';

class NotificationService {
  async getNotifications() {
    try {
      const response = await apiClient.get('/compliance/notifications');
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch notifications.';
    }
  }

  async getUnreadNotifications() {
    try {
      const response = await apiClient.get('/compliance/notifications/unread');
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch unread notifications.';
    }
  }

  async getUnreadCount() {
    try {
      const response = await apiClient.get('/compliance/notifications/unread-count');
      return response.data.data ?? response.data;
    } catch (error) {
      // Fail silently — don't break the UI if this fails
      return 0;
    }
  }

  async markAsRead(id) {
    try {
      const response = await apiClient.put(`/compliance/notifications/${id}/read`);
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to mark notification as read.';
    }
  }

  async markAllAsRead() {
    try {
      const response = await apiClient.put('/compliance/notifications/read-all');
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to mark all notifications as read.';
    }
  }

  async deleteNotification(id) {
    try {
      await apiClient.delete(`/compliance/notifications/${id}`);
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete notification.';
    }
  }

  async syncNotifications() {
    try {
      const response = await apiClient.post('/compliance/notifications/sync-system');
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to sync notifications.';
    }
  }
}

export default new NotificationService();
